const SEO = [
	{
		page: "home",
		description:
			"I am a software developer with expertise in React Native and ReactJs. I have experience in building scalable, secure and reliable web and mobile applications using various frameworks and technologies such as ReactJs, NodeJs and React Native.",
		keywords: ["Shane", "Shane C", "Shane Coelho"],
	},

	{
		page: "about",
		description:
			"I am a software developer with expertise in React Native and ReactJs. I have experience in building scalable, secure and reliable web and mobile applications using various frameworks and technologies such as ReactJs, NodeJs and React Native.",
		keywords: ["Shane", "Shane C", "Shane Coelho"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Shane", "Shane C", "Shane Coelho"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Shane", "Shane C", "Shane Coelho"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Shane", "Shane C", "Shane Coelho"],
	},
];

export default SEO;
